<st-view-state
    *ngrxLet="{ general: viewStateGeneralType$, type: viewStateType$ } as viewStateType"
    class="discover-view-state-container"
    [onBack]="onBack"
    [onAddViewState]="onAddViewState">
    @if (isLoading$ | ngrxPush) {
        <st-loader
            class="st-discover-view-state-loader"
            [diameter]="200"
            [strokeWidth]="10" />
    } @else {
        @if (((inAddContentSourceMode$ | ngrxPush) && (mutipleFeedViewStateMode$ | ngrxPush) === mutipleFeedViewStateModes.CONFIGURE) || !(inAddContentSourceMode$ | ngrxPush)) {
            <div class="st-discover-view-state-header">
                <st-text-area-overlay
                    class="st-discover-view-state-header__title"
                    minHeight="2rem"
                    panelClass="st-discover-view-state-header__title"
                    [value]="viewStateTitle$ | ngrxPush"
                    [placeholder]="languageSettings.PSTWebAddViewTitleLabel"
                    [required]="true"
                    (changed)="updateTitle($event)" />
            </div>
        }
        @if ((inAddContentSourceMode$ | ngrxPush) && viewStateType.type === viewStateTypes.MULTIPLEFEED && (mutipleFeedViewStateMode$ | ngrxPush) === mutipleFeedViewStateModes.BROWSE) {
            <div class="st-discover-view-state-header">
                <div class="st-discover-view-state-header__label">{{ languageSettings.PSTWebSelectContentSourceLabel }}</div>
            </div>
        }
        @if (!(inAddContentSourceMode$ | ngrxPush)) {
            <mat-button-toggle-group
                name="feedType"
                aria-label="Feed Type"
                class="st-view-state-form-full-width"
                required
                [ngModel]="viewStateType.general"
                (change)="updateGeneralViewStateType($event.value)">
                <mat-button-toggle
                    class="st-view-state-form-full-width-button-toggle"
                    [disabled]="inEditMode$ | ngrxPush"
                    [value]="generalViewStateTypes.SINGLEFEED">
                    {{ languageSettings.PSTWebSingleContentViewSourceLabel }}</mat-button-toggle
                >
                <mat-button-toggle
                    class="st-view-state-form-full-width-button-toggle"
                    [disabled]="inEditMode$ | ngrxPush"
                    [value]="generalViewStateTypes.MULTIPLEFEED">
                    {{ languageSettings.PSTWebMultipleContentViewSourceLabel }}</mat-button-toggle
                >
            </mat-button-toggle-group>
        }

        @if (inAddContentSourceMode$ | ngrxPush) {
            <mat-button-toggle-group
                class="st-view-state-form-full-width"
                required
                [ngModel]="mutipleFeedViewStateMode$ | ngrxPush"
                (change)="updateMultipleFeedViewStateMode($event.value)">
                <mat-button-toggle
                    class="st-view-state-form-full-width-button-toggle"
                    [value]="mutipleFeedViewStateModes.BROWSE">
                    {{ languageSettings.PSTWebBrowseLabel }}</mat-button-toggle
                >
                <mat-button-toggle
                    class="st-view-state-form-full-width-button-toggle"
                    [value]="mutipleFeedViewStateModes.CONFIGURE">
                    {{ languageSettings.PSTWebConfigureLabel }}</mat-button-toggle
                >
            </mat-button-toggle-group>
        }

        <mat-tab-group>
            @if (
                viewStateType.general === generalViewStateTypes.SINGLEFEED || ((inAddContentSourceMode$ | ngrxPush) && (mutipleFeedViewStateMode$ | ngrxPush) === mutipleFeedViewStateModes.CONFIGURE)
            ) {
                <mat-tab
                    class="st-view-state-tab"
                    [label]="languageSettings.PSTWebContentLabel">
                    <div class="st-discover-view-state-tab-content">
                        <span class="st-discover-view-state-tab-content__type-view__label">Type</span>
                        <mat-radio-group
                            class="st-discover-view-state-tab-content__type-view-radio-group"
                            [ngModel]="viewStateType.type"
                            (change)="updateViewStateType($event.value)">
                            <mat-radio-button
                                [value]="viewStateTypes.RSSFEED"
                                [disabled]="isRssFeedsDisabled$ | ngrxPush"
                                >{{ languageSettings.PSTWebDiscoverRSSFeedLabel }}</mat-radio-button
                            >
                            <mat-radio-button
                                [value]="viewStateTypes.APFEED"
                                [disabled]="isAPFeedsDisabled$ | ngrxPush"
                                >{{ apFeedLabel$ | ngrxPush }}</mat-radio-button
                            >
                            <mat-radio-button
                                [value]="viewStateTypes.FTPFEED"
                                [disabled]="isFTPFeedsDisabled$ | ngrxPush"
                                >{{ ftpFeedLabel$ | ngrxPush }}</mat-radio-button
                            >
                            <mat-radio-button
                                [value]="viewStateTypes.TWITTERFEED"
                                [disabled]="isTwitterFeedsDisabled$ | ngrxPush"
                                >{{ languageSettings.PSTWebDiscoverTwitterFeedFeedLabel }}</mat-radio-button
                            >
                        </mat-radio-group>

                        @if (viewStateType.type === viewStateTypes.RSSFEED) {
                            <mat-form-field class="st-view-state-form-full-width">
                                <mat-label>{{ languageSettings.PSTWebDiscoverEnterURLHereLabel }}</mat-label>
                                <input
                                    matInput
                                    required
                                    [disabled]="!(inAddContentSourceMode$ | ngrxPush) && (inEditMode$ | ngrxPush)"
                                    [ngModel]="viewStateFeedURL$ | ngrxPush"
                                    (ngModelChange)="updateViewStateFeedURL($event)" />
                                <mat-hint>http://example.com or https://example.com</mat-hint>
                            </mat-form-field>
                        }
                        @if (viewStateType.type === viewStateTypes.APFEED) {
                            <mat-form-field class="st-view-state-form-full-width">
                                <mat-label>{{ apFeedLabel$ | ngrxPush }}</mat-label>
                                <mat-select
                                    required
                                    [disabled]="!(inAddContentSourceMode$ | ngrxPush) && (inEditMode$ | ngrxPush)"
                                    [ngModel]="viewStateFeedID$ | ngrxPush"
                                    (selectionChange)="updateViewStateFeedID($event?.value)">
                                    @for (feed of apFeeds$ | ngrxPush; track feed.id) {
                                        <mat-option [value]="feed.id">{{ feed.name }}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        }
                        @if (viewStateType.type === viewStateTypes.FTPFEED) {
                            <mat-form-field class="st-view-state-form-full-width">
                                <mat-label>{{ ftpFeedLabel$ | ngrxPush }}</mat-label>
                                <mat-select
                                    required
                                    [disabled]="!(inAddContentSourceMode$ | ngrxPush) && (inEditMode$ | ngrxPush)"
                                    [ngModel]="viewStateFeedID$ | ngrxPush"
                                    (selectionChange)="updateViewStateFeedID($event?.value)">
                                    @for (feed of ftpFeeds$ | ngrxPush; track feed.id) {
                                        <mat-option [value]="feed.id">{{ feed.name }}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        }
                        @if (viewStateType.type === viewStateTypes.TWITTERFEED) {
                            <mat-form-field class="st-view-state-form-full-width">
                                <mat-chip-grid
                                    #twitterChipGrid
                                    [disabled]="!(inAddContentSourceMode$ | ngrxPush) && (inEditMode$ | ngrxPush)">
                                    @for (twitterUsername of twitterUsernames; track twitterUsername) {
                                        <mat-chip-row
                                            [editable]="true"
                                            (removed)="removeTwitterUsername(twitterUsername)"
                                            (edited)="editTwitterUsername(twitterUsername, $event)">
                                            <div class="CircleSVG"></div>
                                            {{ twitterUsername }}
                                            <button
                                                matChipRemove
                                                [attr.aria-label]="'Remove ' + twitterUsername">
                                                <mat-icon>close</mat-icon>
                                            </button>
                                        </mat-chip-row>
                                    }
                                </mat-chip-grid>
                                <input
                                    required
                                    [placeholder]="languageSettings.PSTWebDiscoverEnterAccountNameLabel"
                                    [matChipInputFor]="twitterChipGrid"
                                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                    [matChipInputAddOnBlur]="true"
                                    (matChipInputTokenEnd)="addTwitterUsername($event)" />
                                <mat-hint>Account names start with "&#64;".Example &#64;JohnDoe, &#64;JaneDoe, &#64;Example123 </mat-hint>
                            </mat-form-field>
                        }
                    </div>
                </mat-tab>
            }

            @if (!(inAddContentSourceMode$ | ngrxPush) && viewStateType.general === generalViewStateTypes.MULTIPLEFEED && (mutipleFeedViewStateMode$ | ngrxPush) === mutipleFeedViewStateModes.NONE) {
                <mat-tab
                    class="st-view-state-tab"
                    [label]="languageSettings.PSTWebContentLabel">
                    <div class="st-discover-view-state-tab-content">
                        <div
                            *ngrxLet="viewStateSequence$ as viewStateSequence"
                            class="st-discover-view-state-tab-multiple-content">
                            @if (viewStateSequence && !viewStateSequence.Valid) {
                                <div class="st-discover-view-state-tab-required-missing">
                                    <div class="st-discover-view-state-tab-multiple-content-missing__label">There are no content sources currently associated to this view.</div>
                                    <button
                                        mat-stroked-button
                                        color="primary"
                                        class="st-discover-view-state-tab-multiple-content-missing__add"
                                        (click)="onAddCountentSource()">
                                        {{ '+ ' + languageSettings.PSTWebAddContentSourceLabel }}
                                    </button>
                                </div>
                            } @else {
                                <div class="st-discover-view-state-tab-multiple-content-filter-buttons">
                                    <button
                                        mat-stroked-button
                                        color="primary"
                                        class="st-discover-view-state-tab-multiple-content-filter-buttons__add"
                                        (click)="onAddCountentSource()">
                                        {{ '+ ' + languageSettings.PSTWebAddContentSourceLabel }}
                                    </button>

                                    @if (viewStateSequence && viewStateSequence.Valid) {
                                        <button
                                            mat-flat-button
                                            class="st-discover-view-state-tab-multiple-content-filter-buttons__clear-all"
                                            (click)="onRemoveAllContentSource()">
                                            {{ languageSettings.PSTWebRemoveAllLabel }}
                                        </button>
                                    }
                                </div>
                                <mat-list
                                    role="list"
                                    class="st-discover-view-state-tab-multiple-content__list">
                                    @for (vs of viewStateSequenceSelected$ | ngrxPush; track vs.Guid) {
                                        <mat-list-item role="listitem">
                                            <div class="st-discover-view-state-tab-multiple-content__list--header">
                                                @if (vs.Type === viewStateTypes.RSSFEED) {
                                                    <mat-icon> rss_feed </mat-icon>
                                                }
                                                @if (vs.Type === viewStateTypes.APFEED) {
                                                    <mat-icon> satellite_alt </mat-icon>
                                                }
                                                @if (vs.Type === viewStateTypes.FTPFEED) {
                                                    <mat-icon> satellite_alt </mat-icon>
                                                }
                                                @if (vs.Type === viewStateTypes.TWITTERFEED) {
                                                    <mat-icon>
                                                        <svg
                                                            width="20"
                                                            height="20"
                                                            viewBox="0 0 20 20"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M16.1875 2.375H3.8125C2.86328 2.375 2.125 3.14844 2.125 4.0625V16.4375C2.125 17.3867 2.86328 18.125 3.8125 18.125H16.1875C17.1016 18.125 17.875 17.3867 17.875 16.4375V4.0625C17.875 3.14844 17.1016 2.375 16.1875 2.375ZM14.4648 7.96484C14.4648 8.07031 14.4648 8.17578 14.4648 8.28125C14.4648 11.3047 12.1445 14.8203 7.89063 14.8203C6.58984 14.8203 5.39453 14.4688 4.375 13.8008C4.55078 13.8359 4.72656 13.8359 4.90234 13.8359C5.99219 13.8359 6.97656 13.4492 7.78516 12.8516C6.76563 12.8164 5.92188 12.1484 5.60547 11.2344C5.99219 11.3047 6.30859 11.3047 6.66016 11.1992C5.60547 10.9883 4.83203 10.0742 4.83203 8.94922V8.91406C5.11328 9.08984 5.46484 9.19531 5.85156 9.19531C5.21875 8.77344 4.83203 8.07031 4.83203 7.29688C4.83203 6.83984 4.9375 6.45312 5.14844 6.10156C6.27344 7.50781 7.99609 8.42188 9.89453 8.52734C9.57813 6.98047 10.7383 5.67969 12.1445 5.67969C12.8125 5.67969 13.4102 5.96094 13.832 6.41797C14.3594 6.3125 14.8516 6.13672 15.3086 5.85547C15.1328 6.41797 14.7461 6.83984 14.2891 7.12109C14.7461 7.08594 15.2031 6.94531 15.625 6.76953C15.3086 7.22656 14.8867 7.64844 14.4648 7.96484Z"
                                                                fill="currentColor" />
                                                        </svg>
                                                    </mat-icon>
                                                }
                                                {{ vs.Title }}
                                            </div>
                                            <button
                                                class="st-discover-view-state-tab-multiple-content__list--btnRemove"
                                                mat-button
                                                (click)="onRemoveContentSource(vs.Guid)">
                                                {{ languageSettings.PSTWebRemoveLabel }}
                                            </button>
                                        </mat-list-item>
                                    }
                                </mat-list>
                            }
                        </div>
                    </div>
                </mat-tab>
            }

            @if (!(inAddContentSourceMode$ | ngrxPush) || ((inAddContentSourceMode$ | ngrxPush) && (mutipleFeedViewStateMode$ | ngrxPush) === mutipleFeedViewStateModes.CONFIGURE)) {
                <mat-tab [label]="languageSettings.PSTWebSettingsBar">
                    <div
                        *ngrxLet="viewStateLayout$ as viewStateLayout"
                        class="st-discover-view-state-tab-settings">
                        <span class="st-discover-view-state-tab-settings-default-layout__label">{{ languageSettings.PSTWebDefLayoutLabel }}</span>
                        <button
                            class="st-discover-view-state-tab-settings-default-layout__button"
                            mat-stroked-button
                            [matMenuTriggerFor]="layoutMenu">
                            {{ viewStateLayout?.Label }} {{ languageSettings.PSTWebViewLabel }}
                        </button>
                        <mat-menu #layoutMenu="matMenu">
                            <mat-selection-list
                                class="st-discover-view-state-tab-settings__selection-list"
                                hideSingleSelectionIndicator
                                [multiple]="false"
                                (selectionChange)="updateLayout(viewStateLayout, $event?.options?.[0]?.value)">
                                @for (option of viewStateLayout?.Options; track option.id) {
                                    <mat-list-option [value]="option.id">
                                        <div
                                            matListItemTitle
                                            [dir]="isRTL">
                                            {{ option.title }}
                                        </div>
                                    </mat-list-option>
                                }
                            </mat-selection-list>
                        </mat-menu>
                    </div>

                    <div
                        *ngrxLet="viewStateGroupBy$ as viewStateGroupBy"
                        class="st-discover-view-state-tab-settings">
                        <span class="st-discover-view-state-tab-settings-default-grouping__label"> {{ languageSettings.PSTWebDefContGroupByCriteriaLabel }}</span>
                        <button
                            class="st-discover-view-state-tab-settings-default-grouping__button"
                            mat-stroked-button
                            [matMenuTriggerFor]="groupingMenu">
                            {{ viewStateGroupBy?.Label }}
                        </button>
                        <mat-menu #groupingMenu="matMenu">
                            <mat-selection-list
                                hideSingleSelectionIndicator
                                [multiple]="false"
                                (selectionChange)="updateGroupBy(viewStateGroupBy, $event?.options?.[0]?.value)">
                                @for (option of viewStateGroupBy?.Options; track option.id) {
                                    <mat-list-option
                                        [value]="option.id"
                                        [dir]="isRTL">
                                        <div matListItemTitle>{{ option.title }}</div>
                                    </mat-list-option>
                                }
                            </mat-selection-list>
                        </mat-menu>
                    </div>

                    <div class="st-discover-view-state-tab-settings">
                        <span class="st-discover-view-state-tab-settings-default-grouping-order__label">{{ languageSettings.PSTWebGroupSortOrderLabel }} </span>
                        <button
                            mat-mini-fab
                            (click)="toggleGroupSortOrder()">
                            <mat-icon> {{ viewStateGroupByIcon$ | ngrxPush }} </mat-icon>
                        </button>
                    </div>

                    <div
                        *ngrxLet="viewStateSortBy$ as viewStateSortBy"
                        class="st-discover-view-state-tab-settings">
                        <span class="st-discover-view-state-tab-settings-default-sorting__label"> {{ languageSettings.PSTWebDefContSortByCriteriaLabel }}</span>
                        <button
                            mat-stroked-button
                            class="st-discover-view-state-tab-settings-default-sorting__button"
                            [matMenuTriggerFor]="sortingMenu">
                            {{ viewStateSortBy?.Label }}
                        </button>
                        <mat-menu #sortingMenu="matMenu">
                            <mat-selection-list
                                hideSingleSelectionIndicator
                                [multiple]="false"
                                (selectionChange)="updateSortBy(viewStateSortBy, $event?.options?.[0]?.value)">
                                @for (option of viewStateSortBy?.AllOptions; track option.id) {
                                    <mat-list-option
                                        [value]="option.id"
                                        [dir]="isRTL">
                                        <div matListItemTitle>{{ option.title }}</div>
                                    </mat-list-option>
                                }
                            </mat-selection-list>
                        </mat-menu>
                    </div>

                    <div class="st-discover-view-state-tab-settings">
                        <span class="st-discover-view-state-tab-settings-default-grouping-order__label"> {{ languageSettings.PSTWebContentSortOrder }} </span>
                        <button
                            mat-mini-fab
                            (click)="toggleSortOrder()">
                            <mat-icon> {{ viewStateSortByIcon$ | ngrxPush }} </mat-icon>
                        </button>
                    </div>
                </mat-tab>
            }

            @if (!(inAddContentSourceMode$ | ngrxPush) || ((inAddContentSourceMode$ | ngrxPush) && (mutipleFeedViewStateMode$ | ngrxPush) === mutipleFeedViewStateModes.CONFIGURE)) {
                <mat-tab
                    *ngrxLet="viewStateFilter$ as viewStateFilter"
                    [label]="languageSettings.PSTWebRequiredFiltersLabel">
                    <div class="st-discover-view-state-tab-required">
                        @if (viewStateHasRequiredFilters$ | ngrxPush) {
                            <div class="st-discover-view-state-tab-required-filter-buttons">
                                <button
                                    mat-stroked-button
                                    color="primary"
                                    class="st-discover-view-state-tab-required-filter-buttons__add"
                                    [matMenuTriggerFor]="listRequiredFilterDropDownMenu">
                                    {{ '+ ' + languageSettings.PSTWebAddFilterLabel }}
                                </button>

                                <button
                                    mat-flat-button
                                    class="st-discover-view-state-tab-required-filter-buttons__clear-all"
                                    (click)="onClearAllFilters(true)">
                                    {{ languageSettings.PSTWebClearAllLabel }}
                                </button>
                            </div>
                        } @else {
                            <div class="st-discover-view-state-tab-required-missing">
                                <div class="st-discover-view-state-tab-required-missing__label">There are no required filters configured currently for this view.</div>
                                <button
                                    mat-stroked-button
                                    color="primary"
                                    class="st-discover-view-state-tab-required-missing__add"
                                    [matMenuTriggerFor]="listRequiredFilterDropDownMenu">
                                    {{ '+ ' + languageSettings.PSTWebAddFilterLabel }}
                                </button>
                            </div>
                        }
                        <mat-menu #listRequiredFilterDropDownMenu="matMenu">
                            <mat-selection-list
                                st-click-stop-propagation
                                [ngModel]="viewStateRequiredFiltersIDs$ | ngrxPush"
                                (selectionChange)="onFilterStateChange($event, true)">
                                @for (item of viewStateAllFilters$ | ngrxPush; track item.ID) {
                                    <mat-list-option
                                        [disabled]="!item.NotUsed && !item.IsRequired"
                                        [dir]="isRTL"
                                        [value]="item.ID">
                                        {{ item.DefaultCaption }}
                                    </mat-list-option>
                                }
                            </mat-selection-list>
                        </mat-menu>
                        <st-filter-list
                            [disabled]="false"
                            [filters]="viewStateRequiredFilters$ | ngrxPush"
                            [filterType]="filterTypes.REQUIRED"
                            (remove)="onRemoveFilter($event, filterTypes.REQUIRED)" />
                    </div>
                </mat-tab>
            }

            @if (!(inAddContentSourceMode$ | ngrxPush) || ((inAddContentSourceMode$ | ngrxPush) && (mutipleFeedViewStateMode$ | ngrxPush) === mutipleFeedViewStateModes.CONFIGURE)) {
                <mat-tab
                    *ngrxLet="viewStateFilter$ as viewStateFilter"
                    [label]="languageSettings.PSTWebOptionalFiltersLabel">
                    <div class="st-discover-view-state-tab-optional">
                        @if (viewStateHasOptionalFilters$ | ngrxPush) {
                            <div class="st-discover-view-state-tab-optional-filter-buttons">
                                <button
                                    mat-stroked-button
                                    color="primary"
                                    class="st-discover-view-state-tab-optional-filter-buttons__add"
                                    [matMenuTriggerFor]="listOptionalFilterDropDownMenu">
                                    {{ '+ ' + languageSettings.PSTWebAddFilterLabel }}
                                </button>

                                <button
                                    mat-flat-button
                                    class="st-discover-view-state-tab-optional-filter-buttons__clear-all"
                                    (click)="onClearAllFilters(false)">
                                    {{ languageSettings.PSTWebClearAllLabel }}
                                </button>
                            </div>
                        } @else {
                            <div class="st-discover-view-state-tab-optional-missing">
                                <div class="st-discover-view-state-tab-optional-missing__label">There are no optional filters configured currently for this view.</div>
                                <button
                                    mat-stroked-button
                                    color="primary"
                                    class="st-discover-view-state-tab-optional-missing__add"
                                    [matMenuTriggerFor]="listOptionalFilterDropDownMenu">
                                    {{ '+ ' + languageSettings.PSTWebAddFilterLabel }}
                                </button>
                            </div>
                        }
                        <mat-menu #listOptionalFilterDropDownMenu="matMenu">
                            <mat-selection-list
                                st-click-stop-propagation
                                [ngModel]="viewStateOptionalFiltersIDs$ | ngrxPush"
                                (selectionChange)="onFilterStateChange($event, false)">
                                @for (item of viewStateAllFilters$ | ngrxPush; track item.ID) {
                                    <mat-list-option
                                        [disabled]="!item.NotUsed && item.IsRequired"
                                        [dir]="isRTL"
                                        [value]="item.ID">
                                        {{ item.DefaultCaption }}
                                    </mat-list-option>
                                }
                            </mat-selection-list>
                        </mat-menu>
                        <st-filter-list
                            [disabled]="false"
                            [filters]="viewStateOptionalFilters$ | ngrxPush"
                            [filterType]="filterTypes.OPTIONAL"
                            (remove)="onRemoveFilter($event, filterTypes.OPTIONAL)" />
                    </div>
                </mat-tab>
            }
        </mat-tab-group>

        @if ((inAddContentSourceMode$ | ngrxPush) && viewStateType.type === viewStateTypes.MULTIPLEFEED && (mutipleFeedViewStateMode$ | ngrxPush) === mutipleFeedViewStateModes.BROWSE) {
            <mat-form-field
                #trigger="cdkOverlayOrigin"
                subscriptSizing="dynamic"
                class="st-discover-view-state-container__filterViewStateSequence"
                cdkOverlayOrigin>
                <input
                    #search
                    matInput
                    class="st-discover-view-state-container__filterViewStateSequence--input"
                    [placeholder]="languageSettings.PSTWebSearchLabel"
                    (input)="filterViewStates(search.value)" />
                <button
                    mat-icon-button
                    matPrefix
                    class="st-discover-view-state-container__filterViewStateSequence--btnSearch">
                    <mat-icon class="material-symbols-outlined">search</mat-icon>
                </button>
            </mat-form-field>
            <mat-chip-listbox
                st-click-stop-propagation
                class="st-discover-view-state-container__filterViewStateSequence--options"
                multiple="true"
                (change)="onFeedTypeChange($event)">
                <mat-chip-option
                    *ngFor="let type of viewStateTypeOptions$ | ngrxPush"
                    [value]="type.id">
                    {{ type.title }}
                </mat-chip-option>
            </mat-chip-listbox>

            <div class="st-discover-view-state-container__viewStateSequence">
                <mat-selection-list
                    *ngrxLet="viewStateSequenceAll$ as viewstates"
                    (selectionChange)="onSelectionChange($event)">
                    @for (vs of viewstates; track vs.Guid) {
                        <mat-list-option
                            [value]="vs.Guid"
                            [selected]="vs.Selected">
                            <div class="st-discover-view-state-container__viewStateSequence--item">
                                @if (vs.Type === viewStateTypes.RSSFEED) {
                                    <mat-icon> rss_feed </mat-icon>
                                }
                                @if (vs.Type === viewStateTypes.APFEED) {
                                    <mat-icon> satellite_alt </mat-icon>
                                }
                                @if (vs.Type === viewStateTypes.FTPFEED) {
                                    <mat-icon> satellite_alt </mat-icon>
                                }
                                @if (vs.Type === viewStateTypes.TWITTERFEED) {
                                    <mat-icon>
                                        <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M16.1875 2.375H3.8125C2.86328 2.375 2.125 3.14844 2.125 4.0625V16.4375C2.125 17.3867 2.86328 18.125 3.8125 18.125H16.1875C17.1016 18.125 17.875 17.3867 17.875 16.4375V4.0625C17.875 3.14844 17.1016 2.375 16.1875 2.375ZM14.4648 7.96484C14.4648 8.07031 14.4648 8.17578 14.4648 8.28125C14.4648 11.3047 12.1445 14.8203 7.89063 14.8203C6.58984 14.8203 5.39453 14.4688 4.375 13.8008C4.55078 13.8359 4.72656 13.8359 4.90234 13.8359C5.99219 13.8359 6.97656 13.4492 7.78516 12.8516C6.76563 12.8164 5.92188 12.1484 5.60547 11.2344C5.99219 11.3047 6.30859 11.3047 6.66016 11.1992C5.60547 10.9883 4.83203 10.0742 4.83203 8.94922V8.91406C5.11328 9.08984 5.46484 9.19531 5.85156 9.19531C5.21875 8.77344 4.83203 8.07031 4.83203 7.29688C4.83203 6.83984 4.9375 6.45312 5.14844 6.10156C6.27344 7.50781 7.99609 8.42188 9.89453 8.52734C9.57813 6.98047 10.7383 5.67969 12.1445 5.67969C12.8125 5.67969 13.4102 5.96094 13.832 6.41797C14.3594 6.3125 14.8516 6.13672 15.3086 5.85547C15.1328 6.41797 14.7461 6.83984 14.2891 7.12109C14.7461 7.08594 15.2031 6.94531 15.625 6.76953C15.3086 7.22656 14.8867 7.64844 14.4648 7.96484Z"
                                                fill="currentColor" />
                                        </svg>
                                    </mat-icon>
                                }
                                {{ vs.Title }}
                            </div>
                        </mat-list-option>
                    }
                </mat-selection-list>
            </div>
        }
    }
</st-view-state>
